<div class="card mt-5">
  <div class="card-body" 
       [attr.data-testid]="item.Attributes.TriggerCoupon ? 'cart-coupon-' + item.Attributes.TriggerCoupon : 'cart-order-discount-' + item.Description">
    <div class="col">
      <div class="row d-flex p-2">
        <div class="col-lg col-md col-sm-9 col-xs-12">
          <h6 class="font-weight-bold mb-3">Order Discount</h6>
          <p>
            <small 
              [class]="item.Attributes.TriggerCoupon ? 'cart-order-coupon-name' : 'cart-order-discount-name'"
            >
              {{ item.Description }}
            </small>
            <br />
            <small 
                class="text-muted" 
                *ngIf="item.Attributes.TriggerCoupon"
            >
                Coupon: <span class="cart-order-coupon-code">{{ item.Attributes.TriggerCoupon }}</span>
            </small>
          </p>
        </div>
        <div class="col-2"
             style="padding-right: 5px !important; padding-left: 5px !important"
             *ngIf="item.Webcode === TalonOneWebCode.T1ODISCOUNT">
          <h6 class="font-weight-bold mb-3">Amount</h6>
          <strong class="cart-order-discount-amount">{{ item.UnitPrice | currency }}</strong>
        </div>
      </div>
      <div class="row d-flex border-bottom" style="padding-bottom: 10px">
        <div class="col-6 d-flex justify-content-start" *ngIf="item.Attributes.TriggerCoupon">
          <div 
              class="small hand btnItem remove-coupon-{{item.Attributes.TriggerCoupon}}" 
              (click)="removeItem()"
          >
              <mdb-icon far icon="trash-alt" ></mdb-icon> Remove
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
